
import React, { useState } from 'react';
import CampaignHeader from './CampaignHeader';
import CampaignOverview from './CampaignOverview';
import ActiveCampaigns from './ActiveCampaigns';
import CreateCampaign from './CreateCampaign';
import CampaignCalendar from './CampaignCalendar';
import CampaignPerformance from './CampaignPerformance';
import CampaignDetail from './CampaignDetail';

const CampaignManagementCore = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  // Handle viewing campaign details
  const handleViewCampaign = (campaignId) => {
    setSelectedCampaign(campaignId);
    setActiveTab('detail');
  };

  // Return to previous view
  const handleBackFromDetail = () => {
    setSelectedCampaign(null);
    setActiveTab('overview');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <CampaignHeader />
      
      {selectedCampaign ? (
        <CampaignDetail 
          campaignId={selectedCampaign} 
          onBack={handleBackFromDetail} 
        />
      ) : (
        <>
          {/* Tab Navigation */}
          <div className="bg-white border-b border-gray-200 mt-6 mx-6 rounded-t-lg">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex -mb-px">
                <button
                  onClick={() => setActiveTab('overview')}
                  className={`py-4 px-6 font-medium text-sm border-b-2 ${
                    activeTab === 'overview'
                      ? 'border-purple-600 text-purple-900'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Overview
                </button>
                <button
                  onClick={() => setActiveTab('active')}
                  className={`py-4 px-6 font-medium text-sm border-b-2 ${
                    activeTab === 'active'
                      ? 'border-purple-600 text-purple-900'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Active Campaigns
                </button>
                <button
                  onClick={() => setActiveTab('calendar')}
                  className={`py-4 px-6 font-medium text-sm border-b-2 ${
                    activeTab === 'calendar'
                      ? 'border-purple-600 text-purple-900'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Calendar View
                </button>
                <button
                  onClick={() => setActiveTab('performance')}
                  className={`py-4 px-6 font-medium text-sm border-b-2 ${
                    activeTab === 'performance'
                      ? 'border-purple-600 text-purple-900'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Performance
                </button>
                <button
                  onClick={() => setActiveTab('create')}
                  className={`py-4 px-6 font-medium text-sm border-b-2 ${
                    activeTab === 'create'
                      ? 'border-purple-600 text-purple-900'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Create Campaign
                </button>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-white shadow-md rounded-b-lg mx-6">
            {activeTab === 'overview' && <CampaignOverview onViewCampaign={handleViewCampaign} />}
            {activeTab === 'active' && <ActiveCampaigns onViewCampaign={handleViewCampaign} />}
            {activeTab === 'calendar' && <CampaignCalendar onViewCampaign={handleViewCampaign} />}
            {activeTab === 'performance' && <CampaignPerformance />}
            {activeTab === 'create' && <CreateCampaign />}
          </div>
        </>
      )}
    </div>
  );
};

export default CampaignManagementCore;
